import { render } from "./SingletrackStudy2022.vue?vue&type=template&id=6514acac"
import script from "./SingletrackStudy2022.vue?vue&type=script&lang=js"
export * from "./SingletrackStudy2022.vue?vue&type=script&lang=js"

import "./SingletrackStudy2022.vue?vue&type=style&index=0&id=6514acac&lang=css"
script.render = render

export default script